import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconTile } from '../ui';
import { USPS } from '../../data/home';

export default function UspRow() {
  const { t } = useTranslation();
  return (
    <ul className="usp-row" aria-label={t('Why book with us')}>
      {USPS.map((u) => (
        <li key={u.label}><IconTile size="sm" icon={u.icon} label={t(u.label)} sub={t(u.sub)} /></li>
      ))}
    </ul>
  );
}
